import { Link, Typography } from '@mui/material';
import { styled, css } from '@mui/material/styles';

import { AttachmentsList } from './AttachmentsList';
import { ControlledInput, ControlledSelect } from '../../components/forms';
import { Error } from '../../components/forms/styles';

const sharedCSS = css`
    padding: 0.75rem;
    margin: 0 0.75rem;
    border: none;
`;

export const StyledFormContainer = styled('div')`
    max-width: 635px;
    padding: 0rem;
    margin: 0 auto;
    background-color: ${(props) => props.theme.palette.background.paper};
`;

export const StyledContainer = styled('div')`
    display: flex;
    flex-direction: column;

    ${sharedCSS}
`;

export const StyledFieldset = styled('fieldset')`
    display: flex;
    flex-direction: column;

    ${sharedCSS}

    border-bottom: 1px solid ${(props) => props.theme.palette.divider};
`;

export const StyledFieldsetAdvanced = styled('fieldset')`
    display: grid;
    grid-template-columns: 1fr 1fr;

    ${sharedCSS}

    grid-row-gap: 1rem;
`;

export const StyledFieldsetInstructors = styled('fieldset')`
    display: flex;
    flex-direction: column;

    ${sharedCSS}
`;

export const StyledInputContainer = styled('div')`
    display: flex;
    flex-direction: column;
    margin-bottom: 1rem;
`;

export const StyledControlledInput = styled(ControlledInput)`
    max-width: 400px;
`;

export const StyledControlledSelect = styled(ControlledSelect)`
    max-width: 400px;
`;

export const StyledAttachmentsList = styled(AttachmentsList)`
    max-width: 400px;

    & > li {
        padding: 0;
    }
`;

export const TimeDateContainer = styled('div')`
    max-width: 400px;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 1rem;
`;

export const StyledLink = styled(Link)`
    text-decoration: none;
`;

export const StyledAttachmentError = styled(Error)`
    max-width: 400px;
`;

export const StyledFormError = styled(Error)`
    padding: 0.75rem;
    margin-left: auto;
`;

export const StyledFormSuccess = styled(Typography)`
    padding: 0.75rem;
    margin-left: auto;
`;
